import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { 
  DocumentTextIcon
} from '@heroicons/react/24/outline';

const MissionVision = () => {
  return (
    <main id="main-content" className="bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Our School
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                Mission & <span className="font-bold">Vision Statement</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Our guiding principles and commitment to excellence in education for every student at P.S. 11X.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Mission */}
            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#630503] to-[#8B4513]"></div>
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Mission</h2>
                <div className="w-16 h-px bg-[#630503]/40"></div>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                PS 11, in partnership with the entire school community, prepares every student for lifelong success through excellence in education.
              </p>
            </div>

            {/* Vision */}
            <div className="bg-white rounded-xl p-8 shadow-xl border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#8B4513] to-[#A0522D]"></div>
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Vision</h2>
                <div className="w-16 h-px bg-[#8B4513]/40"></div>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                We will empower every student to become a life-long learner who is respectful, responsible, and a productive citizen within the global community.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* P.S. 11x Preamble Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              P.S. 11X <span className="font-bold text-[#630503]">Preamble</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
          </div>

          <div className="bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
              {/* Document Preview */}
              <div className="lg:col-span-2 bg-gray-50 p-6 relative">
                <a 
                  href="/assets/documents/mission&vision/PS 11X Preamble.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block group cursor-pointer"
                >
                  <div className="aspect-[4/5] bg-white rounded-lg shadow-inner border border-gray-200 overflow-hidden relative">
                    <img
                      src="/assets/documents/mission&vision/PS 11X Preamble-1.png"
                      alt="PS 11X Preamble Document Preview"
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                      <div className="bg-white/90 text-gray-800 px-4 py-2 rounded-lg font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        Click to open PDF
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              
              {/* Document Info */}
              <div className="p-8 flex flex-col justify-center">
                <div className="flex items-center mb-6">
                  <div className="w-14 h-14 bg-[#A0522D]/10 rounded-xl flex items-center justify-center mr-4">
                    <DocumentTextIcon className="h-8 w-8 text-[#A0522D]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-1">Preamble Document</h3>
                    <p className="text-sm text-gray-500">PDF Document</p>
                  </div>
                </div>
                
                <p className="text-gray-600 leading-relaxed mb-8">
                  View the complete P.S. 11X Preamble document that outlines our foundational principles and commitment to educational excellence.
                </p>
                
                <a 
                  href="/assets/documents/mission&vision/PS 11X Preamble.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center bg-[#630503] hover:bg-[#4a0402] text-white font-bold px-6 py-3 text-sm uppercase tracking-wide transition-all duration-300 shadow-lg hover:shadow-xl rounded-lg"
                >
                  Open Full Document
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Highbridge History Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Highbridge <span className="font-bold text-[#630503]">History</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
          </div>

          <div className="bg-white rounded-xl p-8 lg:p-12 shadow-xl border border-gray-100 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#630503] via-[#8B4513] to-[#A0522D]"></div>
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">P.S. 11X: The Highbridge School</h3>
              <div className="w-24 h-px bg-[#630503]/40"></div>
            </div>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                P.S. 11x: The Highbridge School is a historic school located in the Highbridge section of The Bronx. Named after the High Bridge, the first bridge built in all of New York City by Irish immigrants, the school and community are rich with a deep history and sense of community that spans over 130 years.
              </p>
              
              <div className="bg-white rounded-lg p-6 border border-gray-200 mt-8">
                <p className="text-base text-gray-600 mb-4">
                  To learn more about the history of the High Bridge, visit:
                </p>
                <a 
                  href="https://www.nycgovparks.org/park-features/highbridge-park/high-bridge-history"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-[#630503] hover:bg-[#4a0402] text-white font-bold px-6 py-3 text-sm uppercase tracking-wide transition-all duration-300 shadow-lg hover:shadow-xl rounded-lg"
                >
                  High Bridge History
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default MissionVision; 